import TextField from '@mui/material/TextField';
import Typography from '@mui/material/Typography';
import Box from '@mui/material/Box';

const FormTextFieldPdf = (props) => {
  const { title, defaultValue, width, multiline, rows } = props;
  return (
    <Box style={{ display: 'flex' }}>
      <Typography variant="h6">{title}</Typography>
      <TextField
        sx={{
          width: width ? '50%' : '70%', paddingLeft: '4px;'
        }}
        hiddenLabel
        value={defaultValue}
        variant="standard"
        size="small"
        multiline={multiline}
        rows={rows}
        inputProps={{ readOnly: true }}
      />
    </Box>
  );
};

export default FormTextFieldPdf;
